// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoBox_root__3mW4g","expandIconContainer":"InfoBox_expandIconContainer__1HO2r"};